import React, { memo } from "react";
import PropTypes from "prop-types";
import { Stack, Container } from "investira.react.components";
import { HeaderTemplate } from "../";
import { ScrollContainer } from "../../atoms";
import { Head } from "../../molecules";
import { Breadcrumbs } from "../../organisms";
import FooterTemplate from "../FooterTemplate";

const HEADER_HEIGHT = 144;

const PageTemplate = memo((props) => {
  const {
    title,
    subtitle,
    description,
    head,
    headerRenderActions,
    scrollable = true,
    children,
    maxWidth = "xl",
  } = props;

  return (
    <>
      <Head title={title} description={description}>
        {head}
        <link rel="canonical" href={window.location.toString()} />
      </Head>
      <Stack
        id="page"
        flexGrow={1}
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        {scrollable ? (
          <ScrollContainer>
            <Container maxWidth={maxWidth} sx={{ height: "100%", pb: 8 }}>
              {/* <Container maxWidth={maxWidth} sx={{ pb: 8 }}> */}
              <Breadcrumbs />
              <HeaderTemplate
                title={title}
                subtitle={subtitle}
                renderActions={headerRenderActions}
              />
              <>
                {children}
                <FooterTemplate />
              </>
            </Container>
          </ScrollContainer>
        ) : (
          <Container
            maxWidth={maxWidth}
            sx={{ height: "100%", pb: 8, paddingTop: 3 }}
          >
            <Breadcrumbs />
            <HeaderTemplate
              title={title}
              subtitle={subtitle}
              renderActions={headerRenderActions}
            />
            <Stack
              id="content"
              sx={{
                height: `calc(100% - ${HEADER_HEIGHT}px)`,
              }}
            >
              {children}
              {/* <FooterTemplate /> */}
            </Stack>
          </Container>
        )}
      </Stack>
    </>
  );
});

PageTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  scrollable: PropTypes.bool,
  headerRenderActions: PropTypes.node,
};

PageTemplate.displayName = "PageTemplate";

export default PageTemplate;
